module.exports = {
  API_URL: "https://ggpoker.royalpix.io/api/",
  // API_URL: "http://localhost:8080/api/",
  // API_URL: "https://2a5c-189-59-94-85.ngrok-free.app/api/",
  
}